import type * as GhostCursor from "ghost-cursor-playwright"

export type Cursor = GhostCursor.Cursor
export type CursorClickOpts = GhostCursor.clickOptions
export type CursorMoveOpts = GhostCursor.moveOptions
export type CursorActions = GhostCursor.Actions
